import React from "react";
import Button from "../../../components/Habitacional/core/Button/Button";

import { ReactComponent as Illustration } from "../../../assets/images/home/health.svg";

import ContentSection from "../../../components/Habitacional/ContentSection";

const HealthSection = () => {
  return (
    <ContentSection
      title="Seguro Saúde"
      description="Encontre clínicas e profissionais, baixe as condições gerais, o cartão da gestante e os reajustes de contrato."
      illustration={<Illustration />}
      reverse
      noMargin
    >
      <Button
        variant="primary"
        style={{ marginTop: "32px" }}
        onClick={() => {
          window.open(
            "https://portal.caixaseguradora.com.br/paravoce/saude/Paginas/Seguro-saude.aspx",
            "_blank"
          );
        }}
      >
        Saber mais
      </Button>
    </ContentSection>
  );
};

export default HealthSection;
